import React, { useEffect, useState } from "react";

import {
  Container,
  TextField,
  Typography,
  Button,
  Snackbar,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { adminLoginService } from "./service";
import { adminInfoStorageService } from "../../shared/services";

import "./style.css";
import { getSchema } from "./utils";

const Login = () => {
  const [error, setError] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(getSchema()),
  });
  const navigate = useNavigate();

  // const handleLogin = async (admin) => {
  //   const { data, error } = await adminLoginService(admin);

  //   if (data) {
  //     adminInfoStorageService(data);

  //     if (data["user_type"] === "ADMIN") {
  //       navigate("/dashboard/blog");
  //     } else if (data["user_type"] === "HR") {
  //       navigate("/hr-portal/candidate-listing");
  //     }
  //     return;
  //   }
  //   if (error) {
  //     console.log(errors);
  //     // setError(error);
  //     const errorMessage =
  //       error.response?.data?.message || "An error occurred during login";
  //     setError(errorMessage);
  //     console.log(error.response?.message);

  //     setTimeout(() => {
  //       setError("");
  //     }, 2000);
  //   }
  // };

  const handleLogin = async (admin) => {
    try {
      const response = await adminLoginService(admin);

      // If there's an error in the response (from the service)
      if (response?.error) {
        setError(response.message || "An error occurred during login");
        setTimeout(() => setError(""), 2000);
        return;
      }

      // If successful login
      if (response?.data) {
        adminInfoStorageService(response.data);

        // Navigate based on user type and permissions
        const userType = response.data["user_type"];
        const permissions = response.data["permissions"] || [];

        if (userType === "ADMIN" || permissions.includes("*")) {
          // Admin users go to blog dashboard
          navigate("/dashboard/blog");
        } else if (userType === "HR") {
          // HR users go to candidate listing
          navigate("/hr-portal/candidate-listing");
        } else if (userType === "CONTENT_MANAGER") {
          // Content managers go to first accessible route based on permissions
          if (
            permissions.includes("manage_banners") ||
            permissions.includes("manage_blogs")
          ) {
            navigate("/dashboard/blog");
          } else if (permissions.includes("manage_press")) {
            navigate("/dashboard/newslink");
          } else if (permissions.includes("manage_testimonials")) {
            navigate("/dashboard/testimonial-list");
          } else if (permissions.includes("manage_content_meta_tags")) {
            navigate("/dashboard/category/category-list-application");
          } else if (permissions.includes("manage_dynamic_pages")) {
            navigate("/dashboard/bookinglocation/dynamic-location-routes");
          } else {
            // Fallback to blog if no specific permission matched
            navigate("/dashboard/blog");
          }
        } else {
          // Default fallback
          navigate("/dashboard/blog");
        }
      }
    } catch (error) {
      // This will catch any unexpected errors
      setError("An unexpected error occurred. Please try again.");
      setTimeout(() => setError(""), 2000);
    }
  };

  useEffect(() => {
    localStorage.removeItem("obenev-token");
  }, []);

  console.log("test oben ev", error);
  return (
    <Container className="login-container">
      <Typography className="login-header">ObenEv</Typography>
      <form onSubmit={handleSubmit(handleLogin)}>
        <TextField
          {...register("email")}
          label="Email"
          fullWidth
          variant="outlined"
          error={errors.email}
          helperText={errors.email?.message}
        />
        <TextField
          {...register("password")}
          label="Password"
          type="password"
          fullWidth
          variant="outlined"
          error={errors.password}
          helperText={errors.password?.message}
        />
        <Button fullWidth variant="contained" type="submit">
          Login
        </Button>
      </form>
      <Snackbar
        open={!!error}
        message={error}
        severity="error"
        autoHideDuration={2000}
      />
    </Container>
  );
};

export default Login;
